import React from 'react';

const CityStep = ({ answers, setAnswers }) => {
  const handleChange = (e) => {
    setAnswers(prev => ({
      ...prev,
      city: e.target.value
    }));
  };

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">لطفا شهر محل سکونت خود را وارد کنید</h2>
      <div className="relative">
        <input
          type="text"
          value={answers.city || ''}
          onChange={handleChange}
          placeholder="مثال: تهران"
          className="w-full p-4 text-right border-2 border-gray-200 rounded-lg focus:border-black focus:outline-none transition-all duration-300"
          dir="rtl"
        />
      </div>
    </div>
  );
};

export default CityStep; 